module.exports = __webpack_public_path__ + "img/t-shirt.7fc8298f.png";